import React, { useContext, useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { f, database, storage, auth } from "../config";
import firebase from "firebase";
import db from "../config";
import { GlobalContext } from "../Globalstate";
import Swal from "sweetalert2";
import axios from "axios";

function Withdrawal() {
  const [{ userdetails, loggedin, singleuser, singleuserkyc }, dispatch] =
    useContext(GlobalContext);
  const navigate = useNavigate();
  const [showmodal, setshowmodal] = useState(false);
  const [loading, setloading] = useState(true);
  const [adminusers, setadminusers] = useState([]);
  const [usertofind, setusertofind] = useState("");
  const [hashcode, sethashcode] = useState("");
  const [amount, setamount] = useState("");
  const [status, setstatus] = useState("confirm");
  const [dataAvailable, setdataAvailable] = useState(false);
  const [lastdocument, setlastdocument] = useState(null);

  function cleanDate(d) {
    var date = new Date(d);
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    console.log(
      "Date: " +
        date.getDate() +
        "/" +
        months[date.getMonth() + 1] +
        "/" +
        date.getFullYear() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds()
    );
    return `${date.getDate()} ${
      months[date.getMonth()]
    } ${date.getFullYear()}  ${date.getHours()}  ${date.getMinutes()} ${date.getSeconds()}`;
  }

  useEffect(() => {
    getValueInDollars("btc")
      .then((value) => {
        console.log(`Value of btc is $${value}`);
      })
      .catch((error) => {
        console.error(`Error: ${error}`);
      });

    authcheck();
  }, []);

  const authcheck = async () => {
    setloading(true);
    const userdata = await f.auth().onAuthStateChanged(function (user) {
      if (user) {
        var userid = f.auth().currentUser;
        var userids = userid.uid;
        if (userids == "vKSvpr8AdihqQJ1KT3DCItILBqw2") {
          adminfetchall();
        } else {
          navigate("/login");
        }
      } else {
        navigate("/login");
      }
    });
  };

  const [withdinfoinfo, setwithdinfoinfo] = useState("");
  const [withdinfouserid, setwithdinfouserid] = useState("");
  const [withdinfoall, setwithdinfoall] = useState("");
  const [withdinfoid, setwithdinfoid] = useState("");

  const setSelecteduser = (infoinfo, infouserid, infoall, infoid) => {
    setwithdinfoinfo(infoinfo);
    setwithdinfouserid(infouserid);
    setwithdinfoall(infoall);
    setwithdinfoid(infoid);
    setshowmodal(true);
  };

  const sendWithdrawal = () => {
    if (hashcode !== "") {
      Updatewithdrawal(
        withdinfoinfo,
        withdinfouserid,
        withdinfoall,
        withdinfoid
      );
    } else {
      alert("Please Insert Hash Code");
    }
  };

  const adminfetchall = async () => {
    const data = await db
      .collection("withdrawals")
      .orderBy("timestamp", "desc")
      .limit(10)
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          let User = doc.data();
          User.id = doc.id;
          adminusers.push(User);
        });
        console.log(snapshot.docs[snapshot.docs.length - 1]);
        setlastdocument(snapshot.docs[snapshot.docs.length - 1]);
      });

    setloading(false);
    console.log(adminusers);
    setdataAvailable(true);
  };

  const getNextDocuments = async () => {
    const ref = db
      .collection("withdrawals")
      .orderBy("timestamp", "desc")
      .startAfter(lastdocument || 0)
      .limit(10);
    const data = await ref.get();

    data.docs.forEach((doc) => {
      let User = doc.data();
      User.id = doc.id;
      adminusers.push(User);
    });

    setlastdocument(data.docs[data.docs.length - 1]);
    console.log(data.docs[data.docs.length - 1]);
    console.log(adminusers);
    setdataAvailable(true);
  };

  const Updatewithdrawal = async (
    withdrawalhistorytoupdate,
    UID,
    info,
    withdrawalid
  ) => {
    console.log(withdrawalhistorytoupdate);
    console.log(UID);
    Swal.fire({
      title: `do you want to set this withdrawal transaction as ${status} `,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        console.log(withdrawalhistorytoupdate);
        setloading(true);
        var washingtonRef = db.collection("users").doc(UID);
        washingtonRef
          .update({
            withdrawalhistory: firebase.firestore.FieldValue.arrayRemove(
              withdrawalhistorytoupdate
            ),
          })
          .then(function () {})
          .catch(function (error) {
            console.log(error);
          });
        
        const increment = firebase.firestore.FieldValue.increment(
          parseInt(withdrawalhistorytoupdate.amt)
        );
        washingtonRef.update({
          Totalwithdrawal: increment,
          withdrawalhistory: firebase.firestore.FieldValue.arrayUnion({
            amt: withdrawalhistorytoupdate.amt,
            date: withdrawalhistorytoupdate.date,
            mode: withdrawalhistorytoupdate.mode,
            wallet: withdrawalhistorytoupdate.wallet,
            coin: withdrawalhistorytoupdate.coin,
            status: status,
          }),
        });
        
        SendMailtoClient(
          info.email,
          info.fullname,
          withdrawalhistorytoupdate.amt,
          withdrawalhistorytoupdate.coin,
          withdrawalhistorytoupdate.wallet,
          withdrawalid
        );
        setloading(false);
        alert("status updated successfully");
        Swal.fire("Updated!", "success");
        setstatus("");
      }
    });
  };

  useEffect(() => {
    getValueInDollars("tether")
      .then((value) => {
        console.log(`Value of tether is $${value}`);
      })
      .catch((error) => {
        console.error(`Error: ${error}`);
      });
  }, []);

  async function getValueInDollars(coin) {
    const coinlist = ["bitcoin", "ethereum", "tron", "doge-1", "tether"];
    if (!coinlist.includes(coin)) {
      return "Invalid coin selection";
    }
    try {
      const response = await axios.get(
        `https://api.coingecko.com/api/v3/simple/price?ids=${coin}&vs_currencies=usd`
      );

      const coinData = response.data[coin];
      if (coinData && coinData.usd) {
        const priceInUSD = coinData.usd;
        return priceInUSD;
      } else {
        return "Price data not available";
      }
    } catch (error) {
      console.log(error);
      return "Error fetching data";
    }
  }

  const SendMailtoClient = async (
    email,
    fullname,
    AMT,
    coinTo,
    wall,
    withdrawalid
  ) => {
    setloading(true);
    try {
      const value = await getValueInDollars(coinTo);
      console.log(`Value of ${coinTo} is $${value}`);
      
      const valueOfAmtInCoin = (parseFloat(AMT) / parseFloat(value)).toFixed(6);
      const accountNumber = Math.floor(Math.random() * 9000000000) + 1000000000;

      const htmlToSend = `
        <html>
        <head>
          <style>
            html, body { margin: 0 auto !important; padding: 0 !important; height: 100% !important; width: 100% !important; background: #f1f1f1; }
            * { -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%; }
            div[style*="margin: 16px 0"] { margin: 0 !important; }
            table, td { mso-table-lspace: 0pt !important; mso-table-rspace: 0pt !important; }
            table { border-spacing: 0 !important; border-collapse: collapse !important; table-layout: fixed !important; margin: 0 auto !important; }
            img { -ms-interpolation-mode:bicubic; }
            a { text-decoration: none; }
            *[x-apple-data-detectors], .unstyle-auto-detected-links *, .aBn { border-bottom: 0 !important; cursor: default !important; color: inherit !important; text-decoration: none !important; font-size: inherit !important; font-family: inherit !important; font-weight: inherit !important; line-height: inherit !important; }
            .a6S { display: none !important; opacity: 0.01 !important; }
            .im { color: inherit !important; }
            img.g-img + div { display: none !important; }
            @media only screen and (min-device-width: 320px) and (max-device-width: 374px) { u ~ div .email-container { min-width: 320px !important; } }
            @media only screen and (min-device-width: 375px) and (max-device-width: 413px) { u ~ div .email-container { min-width: 375px !important; } }
            @media only screen and (min-device-width: 414px) { u ~ div .email-container { min-width: 414px !important; } }
            .primary { background: #17bebb; }
            .bg_white { background: #ffffff; }
            .bg_light { background: #f7fafa; }
            .bg_black { background: #000000; }
            .bg_dark { background: rgba(0, 0, 0, .8); }
            .email-section { padding: 2.5em; }
            .btn { padding: 10px 15px; display: inline-block; }
            .btn.btn-primary { border-radius: 5px; background: #17bebb; color: #ffffff; }
            .btn.btn-white { border-radius: 5px; background: #ffffff; color: #000000; }
            .btn.btn-white-outline { border-radius: 5px; background: transparent; border: 1px solid #fff; color: #fff; }
            .btn.btn-black-outline { border-radius: 0px; background: transparent; border: 2px solid #000; color: #000; font-weight: 700; }
            .btn-custom { color: rgba(0, 0, 0, .3); text-decoration: underline; }
            h1, h2, h3, h4, h5, h6 { font-family: 'Work Sans', sans-serif; color: #000000; margin-top: 0; font-weight: 400; }
            body { font-family: 'Work Sans', sans-serif; font-weight: 400; font-size: 15px; line-height: 1.8; color: rgba(0, 0, 0, .4); }
            a { color: #17bebb; }
            .logo h1 { margin: 0; }
            .logo h1 a { color: #17bebb; font-size: 24px; font-weight: 700; font-family: 'Work Sans', sans-serif; }
            .hero { position: relative; z-index: 0; }
            .hero .text { color: rgba(0, 0, 0, .3); }
            .hero .text h2 { color: #000; font-size: 34px; margin-bottom: 1px; font-weight: 300; line-height: 1.2; }
            .hero .text h3 { font-size: 24px; font-weight: 200; }
            .hero .text h2 span { font-weight: 600; color: #000; }
            .product-entry { display: block; position: relative; float: left; padding-top: 0px; }
            .product-entry .text { width: calc(100% - 125px); padding-left: 1px; }
            .product-entry .text h3 { margin-bottom: 0; padding-bottom: 0; }
            .product-entry .text p { margin-top: 0; }
            .product-entry img, .product-entry .text { float: left; }
            ul.social { padding: 0; }
            ul.social li { display: inline-block; margin-right: 10px; }
            .footer { border-top: 1px solid rgba(0, 0, 0, .05); color: rgba(0, 0, 0, .5); }
            .footer .heading { color: #000; font-size: 20px; }
            .footer ul { margin: 0; padding: 0; }
            .footer ul li { list-style: none; margin-bottom: 10px; }
            .footer ul li a { color: rgba(0, 0, 0, 1); }
          </style>
        </head>
        <body>
          <div class="email-container" style="max-width: 600px; margin: 0 auto;">
            <table align="center" role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin: auto;">
              <tr>
                <td valign="top" class="bg_white" style="padding: 1em 2.5em;">
                  <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
                    <tr>
                      <td class="logo" style="text-align: left;">
                        <h1><a href="#">Globalfoxtrades</a></h1>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td valign="middle" class="hero" style="background: #ffffff;">
                  <table>
                    <tr>
                      <td>
                        <div class="text" style="padding: 0 2.5em; text-align: left;">
                          <h2>Hi ${fullname},</h2>
                          <h3>Withdrawal Confirmation</h3>
                          <p><div style="margin: 0; -webkit-text-size-adjust: none; -ms-text-size-adjust: none; mso-line-height-rule: exactly; font-family: arial,'helvetica neue', helvetica, sans-serif; line-height: 21px; color: #333333; font-size: 14px;">Your withdrawal of ${valueOfAmtInCoin} ${coinTo} ($${AMT}) has been confirmed by an Administrator</div></p>
                          <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
                            <tr>
                              <td class="bg_white email-section" style="width: 100%; text-align: left;">
                                <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
                                  <tr>
                                    <td valign="middle" width="100%">
                                      <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                                        <tr>
                                          <td>
                                            <p><strong>Amount:</strong> ${valueOfAmtInCoin}</p>
                                            <p><strong>Coin:</strong> ${coinTo}</p>
                                            <p><strong>USD Equivalent:</strong> $${AMT}</p>
                                            <p><strong>Status:</strong> COMPLETED</p>
                                            <p><strong>Reference No:</strong> ${accountNumber}</p>
                                            <p><strong>Hashcode:</strong> ${hashcode || 'N/A'}</p>
                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td class="bg_white" style="text-align: center; padding: 2.5em;">
                  <p>Regards,<br>Globalfoxtrades Admin</p>
                </td>
              </tr>
            </table>
          </div>
        </body>
        </html>
      `;

      // Switched to use the unified https://activerendbackend.onrender.com/send-mail endpoint
      const response = await axios.post("https://activerendbackend.onrender.com/send-mail", {
        htmlToSend,
        email,
        subject: "Withdrawal Confirmation",
        CompanyName: "Globalfoxtrades",
      });

      console.log(response.data.message);

      // Proceed to delete the withdrawal document upon successful email dispatch
      await db.collection("withdrawals").doc(withdrawalid).delete();
      console.log("Document successfully deleted!");
      Swal.fire("Deleted!", "The withdrawal has been confirmed.", "success");
      navigate("/");
      
    } catch (error) {
      console.error("Error processing withdrawal or sending email:", error);
      Swal.fire("Error!", "Failed to process the withdrawal confirmation.", "error");
    } finally {
      setloading(false);
    }
  };

  const deleteWithdrawal = async (WithdrawalToUpdate, UID, withdrawalid) => {
    Swal.fire({
      title: `do you want to Delete this withdrawal `,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        Increamentacc(WithdrawalToUpdate.amt, UID, withdrawalid);
      }
    });
  };

  const Increamentacc = async (bal, uuid, withdrawalid) => {
    var washingtonRef = db.collection("users").doc(uuid);
    const increment = firebase.firestore.FieldValue.increment(parseFloat(bal));
    washingtonRef
      .update({
        balance: increment,
      })
      .then(function () {
        Swal.fire("Updated!", "success");
      })
      .catch(function (error) {
        alert("Error updating balance");
      });

    db.collection("withdrawals")
      .doc(withdrawalid)
      .delete()
      .then(() => {
        console.log(withdrawalid);
        console.log("Document successfully deleted!");
        Swal.fire("Deleted!", "The withdrawal has been deleted.", "success");
        navigate("/");
      })
      .catch((error) => {
        console.error("Error removing document: ", error);
      });
    setloading(false);
  };

  return (
    <div>
      {/* Site wrapper */}
      <div className="wrapper">
        {/* Navbar */}
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          {/* Left navbar links */}
          <ul className="navbar-nav">
            <li className="nav-item">
              <a
                className="nav-link"
                data-widget="pushmenu"
                href="#"
                role="button"
              >
                <i className="fas fa-bars" />
              </a>
            </li>
          </ul>
        </nav>
        {/* /.navbar */}
        {/* Main Sidebar Container */}
        <aside className="main-sidebar sidebar-dark-primary elevation-4">
          {/* Brand Logo */}
          <a href="https://chainblockinvestment.com" className="brand-link">
            <img
              src="https://img.icons8.com/?size=80&id=68733&format=png"
              className="brand-image img-circle elevation-2"
              style={{ opacity: ".8" }}
              width={30}
            />
            <span className="brand-text font-weight-light">
              Investment Admin
            </span>
          </a>
          {/* Sidebar */}
          <div className="sidebar">
            {/* Sidebar user (optional) */}
            <div className="user-panel mt-3 pb-3 mb-3 d-flex">
              <div className="image">
                <img
                  src="https://img.icons8.com/bubbles/1x/administrator-male.png"
                  className="img-circle elevation-2"
                  alt="User Image"
                />
              </div>
              <div className="info">
                <a href="#" className="d-block">
                  Darkest Mind
                </a>
              </div>
            </div>
            {/* Sidebar Menu */}
            <nav className="mt-2">
              <ul
                className="nav nav-pills nav-sidebar flex-column"
                data-widget="treeview"
                role="menu"
                data-accordion="false"
              >
                <li className="nav-item">
                  <a href="/" className="nav-link">
                    <i className="nav-icon fas fa-tachometer-alt" />
                    <p>Dashboard</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/users" className="nav-link">
                    <i className="nav-icon fas fa-users" />
                    <p>Manage Users</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/deposits" className="nav-link">
                    <i className="nav-icon fas fa-donate" />
                    <p>Manage Deposits</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/withdrawals" className="nav-link">
                    <i className="nav-icon fas fa-hand-holding-usd" />
                    <p>Manage Withdrawals</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/investments" className="nav-link">
                    <i className="nav-icon fas fa-hand-holding-usd" />
                    <p>Manage Investments</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="https://privateemail.com/" className="nav-link">
                    <i className="nav-icon fas fa-envelope" />
                    <p>webmail</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/logout" className="nav-link">
                    <i className="nav-icon fas fa-power-off" />
                    <p>Logout</p>
                  </a>
                </li>
              </ul>
            </nav>
            {/* /.sidebar-menu */}
          </div>
          {/* /.sidebar */}
        </aside>
        {/* Content Wrapper. Contains page content */}
        <div className="content-wrapper" style={{ minHeight: "777px" }}>
          {/* Content Header (Page header) */}
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>Manage Withdrawals</h1>
                </div>
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item">
                      <a href="https://chainblockinvestment.com/admin">Home</a>
                    </li>
                    <li className="breadcrumb-item active">
                      Manage Withdrawals
                    </li>
                  </ol>
                </div>
              </div>
            </div>
            {/* /.container-fluid */}
          </section>
          {/* Main content */}
          <section className="content">
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body p-0">
                        <div className="table-responsive">
                          <div
                            id="withdrawal_table_wrapper"
                            className="dataTables_wrapper dt-bootstrap4 no-footer"
                          >
                            <div className="row">
                              <div className="col-sm-12 col-md-6" />
                              <div className="col-sm-12 col-md-6">
                                <div
                                  id="withdrawal_table_filter"
                                  className="dataTables_filter"
                                >
                                  <label>
                                    Search:
                                    <input
                                      type="search"
                                      className="form-control form-control-sm"
                                      placeholder
                                      aria-controls="withdrawal_table"
                                    />
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12">
                                <table
                                  className="table table-striped dataTable no-footer"
                                  id="withdrawal_table"
                                  data-page-length={20}
                                  role="grid"
                                  aria-describedby="withdrawal_table_info"
                                >
                                  <thead>
                                    <tr role="row">
                                      <th
                                        style={{ width: "1%" }}
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        #
                                      </th>
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      ></th>
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Name
                                      </th>
                                      <th
                                        width="10%"
                                        className="text-right sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        email
                                      </th>
                                      <th
                                        width="5%"
                                        className="text-center sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Usd Equivalent
                                      </th>
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Wallet Address
                                      </th>
                                      <th
                                        width="5%"
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Hash Code
                                      </th>
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Created Date
                                      </th>
                                      <th
                                        className="text-center sorting_disabled"
                                        width="10%"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Action
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {adminusers &&
                                      adminusers.map((info, i) => {
                                        return (
                                          <tr
                                            role="row"
                                            className="odd"
                                            key={info.userid}
                                          >
                                            <td>{i}</td>
                                            <td>
                                              <img
                                                src="https://img.icons8.com/bubbles/1x/administrator-male.png"
                                                className="img-fluid img-circle elevation-2 bg-light"
                                                width="30px"
                                                alt="User Avatar"
                                              />
                                            </td>
                                            <td>{info.fullname}</td>
                                            <td>{info.email}</td>
                                            <td>
                                              $
                                              {parseFloat(
                                                info.info.amt
                                              ).toLocaleString()}
                                            </td>
                                            <td>{info.info.wallet}</td>
                                            <td>{info.info.date}</td>
                                            <td>{cleanDate(info.info.date)}</td>
                                            <td className="text-center">
                                              <button
                                                className="btn btn-dark btn-sm"
                                                onClick={() => {
                                                  setSelecteduser(
                                                    info.info,
                                                    info.userid,
                                                    info,
                                                    info.id
                                                  );
                                                }}
                                              >
                                                <i className="fas fa-check"></i>
                                              </button>

                                              <button
                                                className="btn btn-danger btn-sm"
                                                onClick={() => {
                                                  deleteWithdrawal(
                                                    info.info,
                                                    info.userid,
                                                    info.id
                                                  );
                                                }}
                                              >
                                                <i className="fas fa-trash"></i>
                                                Delete
                                              </button>
                                            </td>
                                          </tr>
                                        );
                                      })}
                                  </tbody>
                                </table>
                              </div>
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={getNextDocuments}
                              >
                                Load more
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* /.card-body */}
                    </div>
                  </div>
                </div>
                {/* /.box */}
              </div>
            </div>
          </section>
          {/* /.content */}
        </div>
        {/* /.content-wrapper */}

        {showmodal && (
          <div
            className="modal right fade show"
            id="user_modal"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-sm partial-width">
              <div className="modal-content">
                <div className="modal-header bg-dark">
                  <h4 className="modal-title">Manage User</h4>
                  <button
                    type="button"
                    className="close text-light"
                    data-dismiss="modal"
                    onClick={() => {
                      setshowmodal(false);
                    }}
                    aria-label="Close"
                  >
                    <span>×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div id="accordion">
                    <div className="card">
                      <div className="card-header" id="headingseventy">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link btn-block collapsed"
                            data-toggle="collapse"
                            data-target="#Referral_collapse"
                            aria-expanded="false"
                            aria-controls="Referral_collapse"
                          >
                            Add The Withdrawal HasCode
                          </button>
                        </h5>
                      </div>
                      <div
                        id="Referral_collapse"
                        className="collapse"
                        aria-labelledby="headingseventy"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12"></div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-7 col-sm-12">
                              <div className="row pt-2">
                                <div className="col-md-12 mx-auto">
                                  <form id="balance_form" className="form-row">
                                    <div className="form-group col-md-12">
                                      <label
                                        htmlFor="coin_amount"
                                        className="mr-sm-2"
                                      >
                                        hash Code:
                                      </label>
                                      <input
                                        type="text"
                                        id="coin_amount_input"
                                        name="coin_amount"
                                        className="form-control"
                                        step="any"
                                        min={0}
                                        onChange={(e) => {
                                          sethashcode(e.target.value);
                                        }}
                                      />
                                    </div>
                                    <div className="form-group">
                                      <button
                                        className="btn btn-primary"
                                        type="button"
                                        id="update_balance_button"
                                        onClick={() => {
                                          sendWithdrawal();
                                        }}
                                      >
                                        Confirm Withdrawal
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card super-admin" hidden>
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link btn-block"
                          id="make_admin_button"
                        >
                          <i className="fas fa-user-shield" /> Make Admin
                        </button>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
        )}

        <footer className="main-footer">
          <div className="float-right d-none d-sm-block">
            <b>Version</b> 3.0.4
          </div>
          <strong>
            Copyright © 2022{" "}
            <a href="https://chainblockinvestment.com">Investment Admin</a>.
          </strong>{" "}
          All rights reserved.
        </footer>
        <div id="sidebar-overlay" />
      </div>
      {/* ./wrapper */}
    </div>
  );
}

export default Withdrawal;

// import React, { useContext, useState, useEffect, useRef } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { f, database, storage, auth } from "../config";
// import firebase from "firebase";
// import db from "../config";
// import { GlobalContext } from "../Globalstate";
// import Swal from "sweetalert2";
// import emailjs from "emailjs-com";
// import axios from "axios";

// function Withdrawal() {
//   const [{ userdetails, loggedin, singleuser, singleuserkyc }, dispatch] =
//     useContext(GlobalContext);
//   const navigate = useNavigate();
//   const [showmodal, setshowmodal] = useState(false);
//   const [loading, setloading] = useState(true);
//   const [adminusers, setadminusers] = useState([]);
//   const [usertofind, setusertofind] = useState("");
//   const [hashcode, sethashcode] = useState("");
//   const [amount, setamount] = useState("");
//   const [status, setstatus] = useState("confirm");
//   const [dataAvailable, setdataAvailable] = useState(false);
//   const [lastdocument, setlastdocument] = useState(null);

//   function cleanDate(d) {
//     var date = new Date(d);
//     var months = [
//       "Jan",
//       "Feb",
//       "Mar",
//       "Apr",
//       "May",
//       "Jun",
//       "Jul",
//       "Aug",
//       "Sep",
//       "Oct",
//       "Nov",
//       "Dec",
//     ];
//     console.log(
//       "Date: " +
//         date.getDate() +
//         "/" +
//         months[date.getMonth() + 1] +
//         "/" +
//         date.getFullYear() +
//         " " +
//         date.getHours() +
//         ":" +
//         date.getMinutes() +
//         ":" +
//         date.getSeconds()
//     );
//     return `${date.getDate()} ${
//       months[date.getMonth()]
//     } ${date.getFullYear()}  ${date.getHours()}  ${date.getMinutes()} ${date.getSeconds()}`;
//   }
//   useEffect(() => {
//     getValueInDollars("btc")
//       .then((value) => {
//         console.log(`Value of  btc is $${value}`);
//       })
//       .catch((error) => {
//         console.error(`Error: ${error}`);
//       });

//     authcheck();
//   }, []);
//   const authcheck = async () => {
//     setloading(true);
//     const userdata = await f.auth().onAuthStateChanged(function (user) {
//       if (user) {
//         var userid = f.auth().currentUser;
//         var userids = userid.uid;
//         if (userids == "vKSvpr8AdihqQJ1KT3DCItILBqw2") {
//           adminfetchall();
//         } else {
//           navigate("/login");
//         }
//         // console.log(adminusers);
//         //  setloggedin(true);
//       } else {
//         navigate("/login");
//       }
//     });
//   };

//   const [withdinfoinfo, setwithdinfoinfo] = useState("");
//   const [withdinfouserid, setwithdinfouserid] = useState("");
//   const [withdinfoall, setwithdinfoall] = useState("");
//   const [withdinfoid, setwithdinfoid] = useState("");

//   const setSelecteduser = (infoinfo, infouserid, infoall, infoid) => {
//     setwithdinfoinfo(infoinfo);
//     setwithdinfouserid(infouserid);
//     setwithdinfoall(infoall);
//     setwithdinfoid(infoid);
//     setshowmodal(true);

//     // navigate("/adminviews");
//     // handleOpen()
//   };

//   const sendWithdrawal = () => {
//     if (hashcode !== "") {
//       Updatewithdrawal(
//         withdinfoinfo,
//         withdinfouserid,
//         withdinfoall,
//         withdinfoid
//       );
//     } else {
//       alert("Please Insert Hash Code");
//     }
//   };

//   const adminfetchall = async () => {
//     const data = await db
//       .collection("withdrawals")
//       .orderBy("timestamp", "desc")
//       .limit(10)
//       .get()
//       .then((snapshot) => {
//         snapshot.forEach((doc) => {
//           let User = doc.data();
//           User.id = doc.id;
//           adminusers.push(User);
//         });
//         console.log(snapshot.docs[snapshot.docs.length - 1]);
//         setlastdocument(snapshot.docs[snapshot.docs.length - 1]);
//       });

//     setloading(false);

//     console.log(adminusers);
//     const set = await setdataAvailable(true);
//   };

//   const getNextDocuments = async () => {
//     const ref = db
//       .collection("withdrawals")
//       .orderBy("timestamp", "desc")
//       .startAfter(lastdocument || 0)
//       .limit(10);
//     const data = await ref.get();

//     data.docs.forEach((doc) => {
//       let User = doc.data();
//       User.id = doc.id;
//       adminusers.push(User);
//     });

//     setlastdocument(data.docs[data.docs.length - 1]);
//     console.log(data.docs[data.docs.length - 1]);
//     console.log(adminusers);
//     setdataAvailable(true);
//   };

//   const Updatewithdrawal = async (
//     withdrawalhistorytoupdate,
//     UID,
//     info,
//     withdrawalid
//   ) => {
//     console.log(withdrawalhistorytoupdate);
//     console.log(UID);
//     Swal.fire({
//       title: `do you want to set this withdrawal transaction as  ${status} `,
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         console.log(withdrawalhistorytoupdate);
//         setloading(true);
//         var washingtonRef = db.collection("users").doc(UID);
//         washingtonRef
//           .update({
//             withdrawalhistory: firebase.firestore.FieldValue.arrayRemove(
//               withdrawalhistorytoupdate
//             ),
//           })
//           .then(function () {})
//           .catch(function (error) {
//             console.log(error);
//           });
//         ///add the array back with status onAuthStateChanged
//         const increment = firebase.firestore.FieldValue.increment(
//           parseInt(withdrawalhistorytoupdate.amt)
//         );
//         var washingtonRef = db.collection("users").doc(UID);
//         washingtonRef.update({
//           Totalwithdrawal: increment,
//           withdrawalhistory: firebase.firestore.FieldValue.arrayUnion({
//             amt: withdrawalhistorytoupdate.amt,
//             date: withdrawalhistorytoupdate.date,
//             mode: withdrawalhistorytoupdate.mode,
//             wallet: withdrawalhistorytoupdate.wallet,
//             coin: withdrawalhistorytoupdate.coin,
//             status: status,
//           }),
//         });
//         // SendMailtoClient(info.email, info.fullname, withdrawalhistorytoupdate.amt, withdrawalhistorytoupdate.coin, withdrawalhistorytoupdate.wallet, withdrawalhistorytoupdate.date, withdrawalhistorytoupdate.Coinequivalent, withdrawalid)
//         SendMailtoClient(
//           info.email,
//           info.fullname,
//           withdrawalhistorytoupdate.amt,
//           withdrawalhistorytoupdate.coin,
//           withdrawalhistorytoupdate.wallet,
//           withdrawalid
//         );
//         setloading(false);
//         alert("status updated successfully");
//         Swal.fire("Updated!", "success");
//         setstatus("");
//         // setshowmodal1(!showmodal1)
//       }
//     });
//   };

//   useEffect(() => {
//     getValueInDollars("tether")
//       .then((value) => {
//         console.log(`Value of  btc is $${value}`);
//       })
//       .catch((error) => {
//         console.error(`Error: ${error}`);
//       });

//     //               // Example usage
//     //   getCoinList()
//     //   .then((coinList) => {
//     //     console.log('Official Coins:', coinList);
//     //   })
//     //   .catch((error) => {
//     //     console.error('Error:', error);
//     //   });
//   }, []);

//   // async function getCoinList() {
//   //     try {
//   //       const response = await axios.get('https://api.coingecko.com/api/v3/coins/list');
//   //       const coinList = response.data;
//   //       return coinList;
//   //     } catch (error) {
//   //       console.error('Error fetching coin list:', error);
//   //       return [];
//   //     }
//   //   }

//   async function getValueInDollars(coin) {
//     const coinlist = ["bitcoin", "ethereum", "tron", "doge-1", "tether"];
//     if (!coinlist.includes(coin)) {
//       return "Invalid coin selection";
//     }
//     try {
//       const response = await axios.get(
//         `https://api.coingecko.com/api/v3/simple/price?ids=${coin}&vs_currencies=usd`
//       );

//       const coinData = response.data[coin];
//       if (coinData && coinData.usd) {
//         const priceInUSD = coinData.usd;
//         return priceInUSD;
//       } else {
//         return "Price data not available";
//       }
//     } catch (error) {
//       console.log(error);
//       return "Error fetching data";
//     }
//   }

//   /////////////////////////////////
//   ///////////////////////////////////
//   /////////////////////////////////
//   async function sendEmail(user, pass, htmlToSend, email, subject) {
//     // https://renderallmybackend.onrender.com/
//     const url = "https://renderallmybackend.onrender.comhttps://activerendbackend.onrender.com/send-mail"; // Replace with your actual server URL
//     try {
//       const response = await axios.post(url, {
//         htmlToSend: htmlToSend,
//         user: user,
//         pass: pass,
//         email: email, //email
//         subject: subject,
//         CompanyName: "Globalfoxtrades",
//       });
//       console.log(response.data.message); // Log the success message
//       Swal.fire("Processing!", "The Withdrawal is Being Processed.", "success");
//     } catch (error) {
//       console.error(error);
//       // Handle errors appropriately, e.g., display error message to the user
//     }
//   }
//   const SendMailtoClient = async (
//     email,
//     fullname,
//     AMT,
//     coinTo,
//     wall,
//     withdrawalid
//   ) => {
//     const accountNumber = Math.floor(Math.random() * 9000000000) + 1000000000;

//     getValueInDollars(coinTo)
//       .then((value) => {
//         console.log(`Value of  btc is $${value}`);
//         ////////// Value Of Amount In Coin
//         const valueOfAmtInCoin = (parseFloat(AMT) / parseFloat(value)).toFixed(
//           6
//         );

//         var templateParams = {
//           to_name: fullname,
//           user_email: email,
//           notification: "Withdrawal",
//           message: ` <div style="margin: 0; -webkit-text-size-adjust: none; -ms-text-size-adjust: none;
//             mso-line-height-rule: exactly; font-family: arial,'helvetica neue', helvetica, sans-serif; line-height: 21px; color: #333333;
//             font-size: 14px;">Your withdrawal of ${valueOfAmtInCoin} ${coinTo} ($${AMT}) has been confirmed by an Administartor
//            </div>`,
//           coin: coinTo,
//           amount: valueOfAmtInCoin,
//           UsdEQUI: AMT,
//           status: "COMPLETED",
//           refNo: accountNumber,
//           hashcode: hashcode,
//         };

//         setloading(false);

//         emailjs
//           .send(
//             "service_i5dij2ss4",
//             "template_66x6akssf",
//             templateParams,
//             "OBveRCBnWJf2IVAessI"
//           )
//           .then(
//             function (response) {
//               setloading(false);
//               db.collection("withdrawals")
//                 .doc(withdrawalid)
//                 .delete()
//                 .then(() => {
//                   console.log(withdrawalid);
//                   console.log("Document successfully updated!");
//                   //navigate("/");
//                   Swal.fire(
//                     "Deleted!",
//                     "the withdrawal has been confirmed.",
//                     "success"
//                   );
//                   navigate("/");
//                 })
//                 .catch((error) => {
//                   console.error("Error removing document: ", error);
//                 });
//             },
//             function (err) {
//               setloading(false);
//               emailjs
//                 .send(
//                   "service_mj5xcccmss0a",
//                   "template_3ccccu5ssdic1",
//                   templateParams,
//                   "amB0f3bGs0j4iMcsscctaI"
//                 )
//                 .then(
//                   function (response) {
//                     db.collection("withdrawals")
//                       .doc(withdrawalid)
//                       .delete()
//                       .then(() => {
//                         console.log(withdrawalid);
//                         console.log("Document successfully updated!");
//                         //navigate("/");
//                         Swal.fire(
//                           "Deleted!",
//                           "the withdrawal has been confirmed.",
//                           "success"
//                         );
//                         navigate("/");
//                       })
//                       .catch((error) => {
//                         console.error("Error removing document: ", error);
//                       });
//                     setloading(false);
//                   },
//                   function (err) {
//                     setloading(false);
//                     emailjs
//                       .send(
//                         "service_54lshddo5",
//                         "template_cyjcccodyy",
//                         templateParams,
//                         "27GUCCygiOBPUNSKdddd"
//                       )
//                       .then(
//                         function (response) {
//                           db.collection("withdrawals")
//                             .doc(withdrawalid)
//                             .delete()
//                             .then(() => {
//                               console.log(withdrawalid);
//                               console.log("Document successfully updated!");
//                               //navigate("/");
//                               Swal.fire(
//                                 "Deleted!",
//                                 "the withdrawal has been confirmed.",
//                                 "success"
//                               );
//                               navigate("/");
//                             })
//                             .catch((error) => {
//                               console.error("Error removing document: ", error);
//                             });
//                           setloading(false);
//                         },
//                         function (err) {
//                           setloading(false);
//                           emailjs
//                             .send(
//                               "service_7ccm68ddd8",
//                               "templadddte_hqhziyp",
//                               templateParams,
//                               "Zky6J7OlqJw2_dddjaUp"
//                             )
//                             .then(
//                               function (response) {
//                                 db.collection("withdrawals")
//                                   .doc(withdrawalid)
//                                   .delete()
//                                   .then(() => {
//                                     console.log(withdrawalid);
//                                     console.log(
//                                       "Document successfully updated!"
//                                     );
//                                     //navigate("/");
//                                     Swal.fire(
//                                       "Deleted!",
//                                       "the withdrawal has been confirmed.",
//                                       "success"
//                                     );
//                                     navigate("/");
//                                   })
//                                   .catch((error) => {
//                                     console.error(
//                                       "Error removing document: ",
//                                       error
//                                     );
//                                   });
//                                 setloading(false);
//                               },
//                               function (err) {
//                                 setloading(false);
//                                 emailjs
//                                   .send(
//                                     "service_ucfdddd9tp",
//                                     "template_4km8dddriz",
//                                     templateParams,
//                                     "qip2NnckDXTAwydddtl2"
//                                   )
//                                   .then(
//                                     function (response) {
//                                       db.collection("withdrawals")
//                                         .doc(withdrawalid)
//                                         .delete()
//                                         .then(() => {
//                                           console.log(withdrawalid);
//                                           console.log(
//                                             "Document successfully updated!"
//                                           );
//                                           //navigate("/");
//                                           Swal.fire(
//                                             "Deleted!",
//                                             "the withdrawal has been confirmed.",
//                                             "success"
//                                           );
//                                           navigate("/");
//                                         })
//                                         .catch((error) => {
//                                           console.error(
//                                             "Error removing document: ",
//                                             error
//                                           );
//                                         });
//                                       setloading(false);
//                                     },
//                                     function (err) {
//                                       setloading(false);
//                                       emailjs
//                                         .send(
//                                           "service_ofxv3jdddl",
//                                           "template_utna5ddddjj",
//                                           templateParams,
//                                           "o2Rrb-WSZgP4q0ddddHkK"
//                                         )
//                                         .then(
//                                           function (response) {
//                                             db.collection("withdrawals")
//                                               .doc(withdrawalid)
//                                               .delete()
//                                               .then(() => {
//                                                 console.log(withdrawalid);
//                                                 console.log(
//                                                   "Document successfully updated!"
//                                                 );
//                                                 //navigate("/");
//                                                 Swal.fire(
//                                                   "Deleted!",
//                                                   "the withdrawal has been confirmed.",
//                                                   "success"
//                                                 );
//                                                 navigate("/");
//                                               })
//                                               .catch((error) => {
//                                                 console.error(
//                                                   "Error removing document: ",
//                                                   error
//                                                 );
//                                               });
//                                             setloading(false);
//                                           },
//                                           function (err) {
//                                             setloading(false);
//                                             ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//                                             //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//                                             ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//                                             //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//                                             const htmlTemplate = `
//                       <html>
//                       <head>
//                         <style>
//                           /* Include your CSS here */
//                           /* What it does: Remove spaces around the email design added by some email clients. */
//                           /* Beware: It can remove the padding / margin and add a background color to the compose a reply window. */
//                           html, body {
//                               margin: 0 auto !important;
//                               padding: 0 !important;
//                               height: 100% !important;
//                               width: 100% !important;
//                               background: #f1f1f1;
//                           }
//                           /* What it does: Stops email clients resizing small text. */
//                           * {
//                               -ms-text-size-adjust: 100%;
//                               -webkit-text-size-adjust: 100%;
//                           }
//                           /* What it does: Centers email on Android 4.4 */
//                           div[style*="margin: 16px 0"] {
//                               margin: 0 !important;
//                           }
//                           /* What it does: Stops Outlook from adding extra spacing to tables. */
//                           table, td {
//                               mso-table-lspace: 0pt !important;
//                               mso-table-rspace: 0pt !important;
//                           }
//                           /* What it does: Fixes webkit padding issue. */
//                           table {
//                               border-spacing: 0 !important;
//                               border-collapse: collapse !important;
//                               table-layout: fixed !important;
//                               margin: 0 auto !important;
//                           }
//                           /* What it does: Uses a better rendering method when resizing images in IE. */
//                           img {
//                               -ms-interpolation-mode:bicubic;
//                           }
//                           /* What it does: Prevents Windows 10 Mail from underlining links despite inline CSS. Styles for underlined links should be inline. */
//                           a {
//                               text-decoration: none;
//                           }
//                           /* What it does: A work-around for email clients meddling in triggered links. */
//                           *[x-apple-data-detectors], .unstyle-auto-detected-links *, .aBn {
//                               border-bottom: 0 !important;
//                               cursor: default !important;
//                               color: inherit !important;
//                               text-decoration: none !important;
//                               font-size: inherit !important;
//                               font-family: inherit !important;
//                               font-weight: inherit !important;
//                               line-height: inherit !important;
//                           }
//                           /* What it does: Prevents Gmail from displaying a download button on large, non-linked images. */
//                           .a6S {
//                               display: none !important;
//                               opacity: 0.01 !important;
//                           }
//                           /* What it does: Prevents Gmail from changing the text color in conversation threads. */
//                           .im {
//                               color: inherit !important;
//                           }
//                           /* If the above doesn't work, add a .g-img class to any image in question. */
//                           img.g-img + div {
//                               display: none !important;
//                           }
//                           /* What it does: Removes right gutter in Gmail iOS app: https://github.com/TedGoas/Cerberus/issues/89 */
//                           /* Create one of these media queries for each additional viewport size you'd like to fix */
//                           /* iPhone 4, 4S, 5, 5S, 5C, and 5SE */
//                           @media only screen and (min-device-width: 320px) and (max-device-width: 374px) {
//                               u ~ div .email-container {
//                                   min-width: 320px !important;
//                               }
//                           }
//                           /* iPhone 6, 6S, 7, 8, and X */
//                           @media only screen and (min-device-width: 375px) and (max-device-width: 413px) {
//                               u ~ div .email-container {
//                                   min-width: 375px !important;
//                               }
//                           }
//                           /* iPhone 6+, 7+, and 8+ */
//                           @media only screen and (min-device-width: 414px) {
//                               u ~ div .email-container {
//                                   min-width: 414px !important;
//                               }
//                           }
//                           .primary {
//                               background: #17bebb;
//                           }
//                           .bg_white {
//                               background: #ffffff;
//                           }
//                           .bg_light {
//                               background: #f7fafa;
//                           }
//                           .bg_black {
//                               background: #000000;
//                           }
//                           .bg_dark {
//                               background: rgba(0, 0, 0, .8);
//                           }
//                           .email-section {
//                               padding: 2.5em;
//                           }
//                           /*BUTTON*/
//                           .btn {
//                               padding: 10px 15px;
//                               display: inline-block;
//                           }
//                           .btn.btn-primary {
//                               border-radius: 5px;
//                               background: #17bebb;
//                               color: #ffffff;
//                           }
//                           .btn.btn-white {
//                               border-radius: 5px;
//                               background: #ffffff;
//                               color: #000000;
//                           }
//                           .btn.btn-white-outline {
//                               border-radius: 5px;
//                               background: transparent;
//                               border: 1px solid #fff;
//                               color: #fff;
//                           }
//                           .btn.btn-black-outline {
//                               border-radius: 0px;
//                               background: transparent;
//                               border: 2px solid #000;
//                               color: #000;
//                               font-weight: 700;
//                           }
//                           .btn-custom {
//                               color: rgba(0, 0, 0, .3);
//                               text-decoration: underline;
//                           }
//                           h1, h2, h3, h4, h5, h6 {
//                               font-family: 'Work Sans', sans-serif;
//                               color: #000000;
//                               margin-top: 0;
//                               font-weight: 400;
//                           }
//                           body {
//                               font-family: 'Work Sans', sans-serif;
//                               font-weight: 400;
//                               font-size: 15px;
//                               line-height: 1.8;
//                               color: rgba(0, 0, 0, .4);
//                           }
//                           a {
//                               color: #17bebb;
//                           }
//                           table {}
//                           /*LOGO*/
//                           .logo h1 {
//                               margin: 0;
//                           }
//                           .logo h1 a {
//                               color: #17bebb;
//                               font-size: 24px;
//                               font-weight: 700;
//                               font-family: 'Work Sans', sans-serif;
//                           }
//                           /*HERO*/
//                           .hero {
//                               position: relative;
//                               z-index: 0;
//                           }
//                           .hero .text {
//                               color: rgba(0, 0, 0, .3);
//                           }
//                           .hero .text h2 {
//                               color: #000;
//                               font-size: 34px;
//                               margin-bottom: 1px;
//                               font-weight: 300;
//                               line-height: 1.2;
//                           }
//                           .hero .text h3 {
//                               font-size: 24px;
//                               font-weight: 200;
//                           }
//                           .hero .text h2 span {
//                               font-weight: 600;
//                               color: #000;
//                           }
//                           /*PRODUCT*/
//                           .product-entry {
//                               display: block;
//                               position: relative;
//                               float: left;
//                               padding-top: 0px;
//                           }
//                           .product-entry .text {
//                               width: calc(100% - 125px);
//                               padding-left: 1px;
//                           }
//                           .product-entry .text h3 {
//                               margin-bottom: 0;
//                               padding-bottom: 0;
//                           }
//                           .product-entry .text p {
//                               margin-top: 0;
//                           }
//                           .product-entry img, .product-entry .text {
//                               float: left;
//                           }
//                           ul.social {
//                               padding: 0;
//                           }
//                           ul.social li {
//                               display: inline-block;
//                               margin-right: 10px;
//                           }
//                           /*FOOTER*/
//                           .footer {
//                               border-top: 1px solid rgba(0, 0, 0, .05);
//                               color: rgba(0, 0, 0, .5);
//                           }
//                           .footer .heading {
//                               color: #000;
//                               font-size: 20px;
//                           }
//                           .footer ul {
//                               margin: 0;
//                               padding: 0;
//                           }
//                           .footer ul li {
//                               list-style: none;
//                               margin-bottom: 10px;
//                           }
//                           .footer ul li a {
//                               color: rgba(0, 0, 0, 1);
//                           }
//                           @media screen and (max-width: 500px) {}
//                         </style>
//                       </head>
//                       <body>
//                         <div class="email-container" style="max-width: 600px; margin: 0 auto;">
//                           <table align="center" role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin: auto;">
//                             <tr>
//                               <td valign="top" class="bg_white" style="padding: 1em 2.5em;">
//                                 <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
//                                   <tr>
//                                     <td class="logo" style="text-align: left;">
//                                       <h1><a href="#">Globalfoxtrades</a></h1>
//                                     </td>
//                                   </tr>
//                                 </table>
//                               </td>
//                             </tr>
//                             <tr>
//                               <td valign="middle" class="hero" style="background: #ffffff;">
//                                 <table>
//                                   <tr>
//                                     <td>
//                                       <div class="text" style="padding: 0 2.5em; text-align: left;">
//                                         <h2>Hi {{to_name}},</h2>
//                                         <h3>{{notification}}</h3>
//                                         <p>{{message}}</p>
//                                         <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
//                                           <tr>
//                                             <td class="bg_white email-section" style="width: 100%; text-align: left;">
//                                               <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
//                                                 <tr>
//                                                   <td valign="middle" width="50%">
//                                                     <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
//                                                       <tr>
//                                                         <td>
//                                                           <p>Amount: {{amount}}</p>
//                                                           <p>Coin: {{coin}}</p>
//                                                           <p>UsdEQUI: {{UsdEQUI}}</p>
//                                                           <p>Status: {{status}}</p>
//                                                           <p>Reference No: {{refNo}}</p>
//                                                           <p>Hashcode: {{hashcode}}</p>
//                                                         </td>
//                                                       </tr>
//                                                     </table>
//                                                   </td>
//                                                 </tr>
//                                               </table>
//                                             </td>
//                                           </tr>
//                                         </table>
//                                       </div>
//                                     </td>
//                                   </tr>
//                                 </table>
//                               </td>
//                             </tr>
//                             <tr>
//                               <td class="bg_white" style="text-align: center; padding: 2.5em;">
//                                 <p>Regards,<br>Your Company</p>
//                               </td>
//                             </tr>
//                           </table>
//                         </div>
//                       </body>
//                       </html>
//                     `;
//                                             const message = ` <div style="margin: 0; -webkit-text-size-adjust: none; -ms-text-size-adjust: none;
//                     mso-line-height-rule: exactly; font-family: arial,'helvetica neue', helvetica, sans-serif; line-height: 21px; color: #333333;
//                     font-size: 14px;">Your withdrawal of ${valueOfAmtInCoin} ${coinTo} ($${AMT}) has been confirmed by an Administartor
//                    </div>`;

//                                             const replacedHtml = htmlTemplate
//                                               .replace(
//                                                 /{{notification}}/g,
//                                                 "Withdrawal"
//                                               )
//                                               .replace(/{{to_name}}/g, fullname)
//                                               .replace(/{{message}}/g, message)
//                                               .replace(
//                                                 /{{amount}}/g,
//                                                 valueOfAmtInCoin
//                                               )
//                                               .replace(/{{coin}}/g, coinTo)
//                                               .replace(/{{UsdEQUI}}/g, AMT)
//                                               .replace(
//                                                 /{{status}}/g,
//                                                 "COMPLETED"
//                                               )
//                                               .replace(
//                                                 /{{refNo}}/g,
//                                                 accountNumber
//                                               )
//                                               .replace(
//                                                 /{{hashcode}}/g,
//                                                 hashcode
//                                               );
//                                               const user = "support@globalsfoxstrades.com"; // Replace with your email
//                                               const pass = "dedede23@sdde"; // Replace with your email password
//                                             const emails = email; // Replace with recipient's email
//                                             const subject = "Withdrawal"; // Replace with the subject of the email
//                                             sendEmail(
//                                               user,
//                                               pass,
//                                               replacedHtml,
//                                               emails,
//                                               subject
//                                             );

//                                             ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//                                             //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//                                             ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//                                             //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//                                             console.log(err);
//                                           }
//                                         );
//                                     }
//                                   );
//                               }
//                             );
//                         }
//                       );
//                     console.log(err);
//                   }
//                 );
//               console.log(err);
//             }
//           );
//       })
//       .catch((error) => {
//         console.error(`Error: ${error}`);
//       });
//   };

//   const deleteWithdrawal = async (WithdrawalToUpdate, UID, withdrawalid) => {
//     //
//     Swal.fire({
//       title: `do you want to Delete this withdrawal `,
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         Increamentacc(WithdrawalToUpdate.amt, UID, withdrawalid);
//         //  SendMailtoClient(info.email, info.fullname, depositToUpdate.amt, depositToUpdate.coin)
//         //console.log(depositToUpdate.amt)
//       }
//     });
//   };

//   const Increamentacc = async (bal, uuid, withdrawalid) => {
//     //increase balance by value
//     var washingtonRef = db.collection("users").doc(uuid);
//     // const balanceToUse = parseFloat(singleuser.balance) + parseFloat(amount)
//     const increment = firebase.firestore.FieldValue.increment(parseFloat(bal));
//     washingtonRef
//       .update({
//         balance: increment,
//       })
//       .then(function () {
//         Swal.fire("Updated!", "success");
//       })
//       .catch(function (error) {
//         alert("Error updating balance");
//       });

//     db.collection("withdrawals")
//       .doc(withdrawalid)
//       .delete()
//       .then(() => {
//         console.log(withdrawalid);
//         console.log("Document successfully deleted!");
//         //navigate("/");
//         Swal.fire("Deleted!", "The Deposit has been deleted.", "success");
//         navigate("/");
//       })
//       .catch((error) => {
//         console.error("Error removing document: ", error);
//       });
//     setloading(false);
//   };

//   return (
//     <div>
//       {/* Site wrapper */}
//       <div className="wrapper">
//         {/* Navbar */}
//         <nav className="main-header navbar navbar-expand navbar-white navbar-light">
//           {/* Left navbar links */}
//           <ul className="navbar-nav">
//             <li className="nav-item">
//               <a
//                 className="nav-link"
//                 data-widget="pushmenu"
//                 href="#"
//                 role="button"
//               >
//                 <i className="fas fa-bars" />
//               </a>
//             </li>
//           </ul>
//         </nav>
//         {/* /.navbar */}
//         {/* Main Sidebar Container */}
//         <aside className="main-sidebar sidebar-dark-primary elevation-4">
//           {/* Brand Logo */}
//           <a href="https://chainblockinvestment.com" className="brand-link">
//             <img
//               src="https://img.icons8.com/?size=80&id=68733&format=png"
//               className="brand-image img-circle elevation-2"
//               style={{ opacity: ".8" }}
//               width={30}
//             />
//             <span className="brand-text font-weight-light">
//               Investment Admin
//             </span>
//           </a>
//           {/* Sidebar */}
//           <div className="sidebar">
//             {/* Sidebar user (optional) */}
//             <div className="user-panel mt-3 pb-3 mb-3 d-flex">
//               <div className="image">
//                 <img
//                   src="https://img.icons8.com/bubbles/1x/administrator-male.png"
//                   className="img-circle elevation-2"
//                   alt="User Image"
//                 />
//               </div>
//               <div className="info">
//                 <a href="#" className="d-block">
//                   Darkest Mind
//                 </a>
//               </div>
//             </div>
//             {/* Sidebar Menu */}
//             <nav className="mt-2">
//               <ul
//                 className="nav nav-pills nav-sidebar flex-column"
//                 data-widget="treeview"
//                 role="menu"
//                 data-accordion="false"
//               >
//                 {/* Add icons to the links using the .nav-icon class
//            with font-awesome or any other icon font library */}
//                 <li className="nav-item">
//                   <a href="/" className="nav-link">
//                     <i className="nav-icon fas fa-tachometer-alt" />
//                     <p>Dashboard</p>
//                   </a>
//                 </li>
//                 {/* <li className="nav-item">
//                                     <a href="/Settings" className="nav-link">
//                                         <i className="nav-icon fas fa-tachometer-alt" />
//                                         <p>
//                                         Coin Deposit
//                                         </p>
//                                     </a>
//                                 </li> */}
//                 <li className="nav-item">
//                   <a href="/users" className="nav-link">
//                     <i className="nav-icon fas fa-users" />
//                     <p>Manage Users</p>
//                   </a>
//                 </li>
//                 <li className="nav-item">
//                   <a href="/deposits" className="nav-link">
//                     <i className="nav-icon fas fa-donate" />
//                     <p>Manage Deposits</p>
//                   </a>
//                 </li>
//                 <li className="nav-item">
//                   <a href="/withdrawals" className="nav-link">
//                     <i className="nav-icon fas fa-hand-holding-usd" />
//                     <p>Manage Withdrawals</p>
//                   </a>
//                 </li>

//                 {/* <li className="nav-item has-treeview">
//                                     <a href="#" className="nav-link">
//                                         <i className="nav-icon fab fa-pagelines" />
//                                         <p>
//                                             Manage Minings
//                                             <i className=" fas fa-angle-left right" />
//                                         </p>
//                                     </a>
//                                     <ul className="nav nav-treeview" style={{ display: 'none' }}>
//                                         <li className="nav-item super-admin" hidden>
//                                             <a href="/admin/mining-plans" className="nav-link">
//                                                 <i className="nav-icon fab" />
//                                                 <p>
//                                                     Plans
//                                                 </p>
//                                             </a>
//                                         </li>
//                                         <li className="nav-item">
//                                             <a href="/admin/all-minings" className="nav-link">
//                                                 <i className="nav-icon fab" />
//                                                 <p>
//                                                     All Minings
//                                                 </p>
//                                             </a>
//                                         </li>
//                                     </ul>
//                                 </li> */}
//                 <li className="nav-item">
//                   <a href="/investments" className="nav-link">
//                     <i className="nav-icon fas fa-hand-holding-usd" />
//                     <p>Manage Investments</p>
//                   </a>
//                 </li>

//                 <li className="nav-item">
//                   <a href="https://privateemail.com/" className="nav-link">
//                     <i className="nav-icon fas fa-envelope" />
//                     <p>webmail</p>
//                   </a>
//                 </li>
//                 <li className="nav-item">
//                   <a href="/logout" className="nav-link">
//                     <i className="nav-icon fas fa-power-off" />
//                     <p>Logout</p>
//                   </a>
//                 </li>
//               </ul>
//             </nav>
//             {/* /.sidebar-menu */}
//           </div>
//           {/* /.sidebar */}
//         </aside>
//         {/* Content Wrapper. Contains page content */}
//         <div className="content-wrapper" style={{ minHeight: "777px" }}>
//           {/* Content Header (Page header) */}
//           <section className="content-header">
//             <div className="container-fluid">
//               <div className="row mb-2">
//                 <div className="col-sm-6">
//                   <h1>Manage Withdrawals</h1>
//                 </div>
//                 <div className="col-sm-6">
//                   <ol className="breadcrumb float-sm-right">
//                     <li className="breadcrumb-item">
//                       <a href="https://chainblockinvestment.com/admin">Home</a>
//                     </li>
//                     <li className="breadcrumb-item active">
//                       Manage Withdrawals
//                     </li>
//                   </ol>
//                 </div>
//               </div>
//             </div>
//             {/* /.container-fluid */}
//           </section>
//           {/* Main content */}
//           <section className="content">
//             <div className="row">
//               <div className="col-md-12">
//                 <div className="row">
//                   <div className="col-md-12">
//                     <div className="card">
//                       <div className="card-body p-0">
//                         <div className="table-responsive">
//                           <div
//                             id="withdrawal_table_wrapper"
//                             className="dataTables_wrapper dt-bootstrap4 no-footer"
//                           >
//                             <div className="row">
//                               <div className="col-sm-12 col-md-6" />
//                               <div className="col-sm-12 col-md-6">
//                                 <div
//                                   id="withdrawal_table_filter"
//                                   className="dataTables_filter"
//                                 >
//                                   <label>
//                                     Search:
//                                     <input
//                                       type="search"
//                                       className="form-control form-control-sm"
//                                       placeholder
//                                       aria-controls="withdrawal_table"
//                                     />
//                                   </label>
//                                 </div>
//                               </div>
//                             </div>
//                             <div className="row">
//                               <div className="col-sm-12">
//                                 <table
//                                   className="table table-striped dataTable no-footer"
//                                   id="withdrawal_table"
//                                   data-page-length={20}
//                                   role="grid"
//                                   aria-describedby="withdrawal_table_info"
//                                 >
//                                   <thead>
//                                     <tr role="row">
//                                       <th
//                                         style={{ width: "1%" }}
//                                         className="sorting_disabled"
//                                         rowSpan={1}
//                                         colSpan={1}
//                                       >
//                                         #
//                                       </th>
//                                       <th
//                                         className="sorting_disabled"
//                                         rowSpan={1}
//                                         colSpan={1}
//                                       ></th>
//                                       <th
//                                         className="sorting_disabled"
//                                         rowSpan={1}
//                                         colSpan={1}
//                                       >
//                                         Name
//                                       </th>
//                                       <th
//                                         width="10%"
//                                         className="text-right sorting_disabled"
//                                         rowSpan={1}
//                                         colSpan={1}
//                                       >
//                                         email
//                                       </th>
//                                       <th
//                                         width="5%"
//                                         className="text-center sorting_disabled"
//                                         rowSpan={1}
//                                         colSpan={1}
//                                       >
//                                         Usd Equivalent
//                                       </th>
//                                       <th
//                                         className="sorting_disabled"
//                                         rowSpan={1}
//                                         colSpan={1}
//                                       >
//                                         Wallet Address
//                                       </th>
//                                       <th
//                                         width="5%"
//                                         className="sorting_disabled"
//                                         rowSpan={1}
//                                         colSpan={1}
//                                       >
//                                         Hash Code
//                                       </th>
//                                       <th
//                                         className="sorting_disabled"
//                                         rowSpan={1}
//                                         colSpan={1}
//                                       >
//                                         Created Date
//                                       </th>
//                                       <th
//                                         className="text-center sorting_disabled"
//                                         width="10%"
//                                         rowSpan={1}
//                                         colSpan={1}
//                                       >
//                                         Action
//                                       </th>
//                                     </tr>
//                                   </thead>
//                                   <tbody>
//                                     {adminusers &&
//                                       adminusers.map((info, i) => {
//                                         return (
//                                           <tr
//                                             role="row"
//                                             className="odd"
//                                             key={info.userid}
//                                           >
//                                             <td>{i}</td>
//                                             <td>
//                                               <img
//                                                 src="https://img.icons8.com/bubbles/1x/administrator-male.png"
//                                                 className="img - fluid img - circle elevation - 2 bg - light"
//                                                 width="30px"
//                                                 alt="User Avatar"
//                                               />
//                                             </td>
//                                             <td>{info.fullname}</td>
//                                             <td>{info.email}</td>
//                                             <td>
//                                               $
//                                               {parseFloat(
//                                                 info.info.amt
//                                               ).toLocaleString()}
//                                             </td>
//                                             <td>{info.info.wallet}</td>
//                                             <td>{info.info.date}</td>
//                                             <td>{cleanDate(info.info.date)}</td>
//                                             {/* <td>
//                                                                             1990-06-11
//                                                                         </td> */}
//                                             <td className="text-center">
//                                               <button
//                                                 className="btn btn-dark btn-sm"
//                                                 onClick={() => {
//                                                   setSelecteduser(
//                                                     info.info,
//                                                     info.userid,
//                                                     info,
//                                                     info.id
//                                                   );
//                                                 }}
//                                               >
//                                                 <i className="fas fa-check"></i>
//                                               </button>

//                                               <button
//                                                 className="btn btn-danger btn-sm"
//                                                 onClick={() => {
//                                                   deleteWithdrawal(
//                                                     info.info,
//                                                     info.userid,
//                                                     info.id
//                                                   );
//                                                 }}
//                                               >
//                                                 <i className="fas fa-trash"></i>
//                                                 Delete
//                                               </button>
//                                             </td>
//                                           </tr>
//                                         );
//                                       })}
//                                   </tbody>
//                                 </table>
//                               </div>
//                               <button
//                                 className="btn btn-danger btn-sm"
//                                 onClick={getNextDocuments}
//                               >
//                                 {/* <i className="fas fa-trash"> */}
//                                 {/* </i> */}
//                                 Load more
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                       {/* /.card-body */}
//                     </div>
//                   </div>
//                 </div>
//                 {/* /.box */}
//               </div>
//             </div>
//           </section>
//           {/* /.content */}
//         </div>
//         {/* /.content-wrapper */}

//         {showmodal && (
//           <div
//             className="modal right fade show"
//             id="user_modal"
//             style={{ display: "block" }}
//           >
//             <div className="modal-dialog modal-dialog-sm partial-width">
//               <div className="modal-content">
//                 <div className="modal-header bg-dark">
//                   <h4 className="modal-title">Manage User</h4>
//                   <button
//                     type="button"
//                     className="close text-light"
//                     data-dismiss="modal"
//                     onClick={() => {
//                       setshowmodal(false);
//                     }}
//                     aria-label="Close"
//                   >
//                     <span>×</span>
//                   </button>
//                 </div>
//                 <div className="modal-body">
//                   <div id="accordion">
//                     <div className="card">
//                       <div className="card-header" id="headingseventy">
//                         <h5 className="mb-0">
//                           <button
//                             className="btn btn-link btn-block collapsed"
//                             data-toggle="collapse"
//                             data-target="#Referral_collapse"
//                             aria-expanded="false"
//                             aria-controls="Referral_collapse"
//                           >
//                             Add The Withdrawal HasCode
//                           </button>
//                         </h5>
//                       </div>
//                       <div
//                         id="Referral_collapse"
//                         className="collapse"
//                         aria-labelledby="headingseventy"
//                         data-parent="#accordion"
//                       >
//                         <div className="card-body">
//                           <div className="row">
//                             <div className="col-md-12"></div>
//                           </div>
//                           <div className="row mb-2">
//                             <div className="col-7 col-sm-12">
//                               {/* <div className="tab-content" id="vert-tabs-tabContent"> */}
//                               {/* <div class="tab-pane text-left fade active show" id="vert-tabs-home" role="tabpanel" aria-labelledby="vert-tabs-home-tab"> */}
//                               <div className="row pt-2">
//                                 <div className="col-md-12 mx-auto">
//                                   <form id="balance_form" className="form-row">
//                                     <div className="form-group col-md-12">
//                                       <label
//                                         htmlFor="coin_amount"
//                                         className="mr-sm-2"
//                                       >
//                                         hash Code:
//                                       </label>
//                                       <input
//                                         type="text"
//                                         id="coin_amount_input"
//                                         name="coin_amount"
//                                         className="form-control"
//                                         step="any"
//                                         min={0}
//                                         onChange={(e) => {
//                                           sethashcode(e.target.value);
//                                         }}
//                                       />
//                                     </div>
//                                     <div className="form-group">
//                                       <button
//                                         className="btn btn-primary"
//                                         type="button"
//                                         id="update_balance_button"
//                                         onClick={() => {
//                                           sendWithdrawal();
//                                         }}
//                                       >
//                                         Confirm WIthdrawal
//                                       </button>
//                                     </div>
//                                   </form>
//                                 </div>
//                               </div>
//                               {/* </div> */}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="card super-admin" hidden>
//                       <h5 className="mb-0">
//                         <button
//                           className="btn btn-link btn-block"
//                           id="make_admin_button"
//                         >
//                           <i className="fas fa-user-shield" /> Make Admin
//                         </button>
//                       </h5>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               {/* /.modal-content */}
//             </div>
//             {/* /.modal-dialog */}
//           </div>
//         )}

//         <footer className="main-footer">
//           <div className="float-right d-none d-sm-block">
//             <b>Version</b> 3.0.4
//           </div>
//           <strong>
//             Copyright © 2022{" "}
//             <a href="https://chainblockinvestment.com">Investment Admin</a>.
//           </strong>{" "}
//           All rights reserved.
//         </footer>
//         <div id="sidebar-overlay" />
//       </div>
//       {/* ./wrapper */}
//       {/* jQuery */}
//       {/* Bootstrap 4 */}
//       {/* AdminLTE App */}
//       {/* Sweet Alert */}
//       {/* Datatable */}
//       {/* for ladda */}
//     </div>
//   );
// }

// export default Withdrawal;
